(function (appComponents) {

	appComponents.services.footer = function (Components) {

		var footer = {};

		footer.name = "footer";


		Components.getComponentPrototype().extend(footer);

		footer.context.footerType = "extended";

		footer.renderFooter = function () {
			var html = footer.templates.main(footer.context);
			footer._elements.footer.replaceWith(html);
		};

		footer.checkFooterStyle = function () {
			var pageFooterType = footer._page.footerType;
			if (pageFooterType != footer.context.footerType) {
				footer.context.footerType = pageFooterType;
				footer.renderFooter();
			}
			if (footer._currentPage.title == "registration") {
				footer._elements.footer.addClass("pos-fix-fot");
			} else {
				footer._elements.footer.removeClass("pos-fix-fot");
			}

		};

		footer.handlers = {
			onPageDataInitialized: function () {
				// footer._elements.footer.hide();
			},
			oncontrollerInitialized: function () {
				footer.checkFooterStyle();
				// footer._elements.footer.show();
			}
		};

		footer.init = function () {
			footer.renderFooter();
			// footer._events.registerHandler("pageDataInitialized", footer.name, footer.handlers.onPageDataInitialized);
			footer._events.registerHandler("controllerInitialized", footer.name, footer.handlers.oncontrollerInitialized);
		};


		return footer;

	};

	window.appComponents = appComponents;

})(window.appComponents || {});